<script setup>
import {onBeforeUnmount, onMounted, ref} from "vue";

const props = defineProps({
	list: {
		type: Array,
		default: () => []
	},
	customStyle: {
		type: Object,
		default: () => ({})
	},
	direction: {
		type: String,
		default: 'left-to-right',
		validator: (value) => ['left-to-right', 'right-to-left'].includes(value)
	}
})

const timer = ref(null)
const container = ref(null)
const mainList = ref(null)
const step = ref(1)
function smoothScrolling() {
	const isLeftToRight = props.direction === 'left-to-right'
	const scrollStep = isLeftToRight ? 1 : -1
	
	if (isLeftToRight) {
		if (container.value.scrollLeft >= mainList.value.clientWidth) {
			container.value.scrollLeft = 0
		} else {
			container.value.scrollLeft += scrollStep
		}
	} else {
		if (container.value.scrollLeft <= 0) {
			container.value.scrollLeft = mainList.value.clientWidth
		} else {
			container.value.scrollLeft += scrollStep
		}
	}
}

function startScrolling(t = 30) {
	timer.value = setInterval(smoothScrolling, t)
	
}

function stopScrolling() {
	clearInterval(timer.value)
}

onMounted(() => {
	startScrolling()
})

onBeforeUnmount(() => {
	stopScrolling()
})

</script>

<template>
	<div class="rolling-container">
		<div
			class="rolling-list"
			id="container"
			ref="container"
		>
			<div class="rolling" ref="mainList">
				<div class="rolling-item" v-for="(item, index) in list" :key="index" :style="customStyle">
					<img :src="item" />
				</div>
			</div>
			
			<div class="rolling">
				<div class="rolling-item" v-for="item in list" :style="customStyle">
					<img :src="item" />
				</div>
			</div>
		</div>
	</div>
	
</template>

<style scoped lang="less">
.rolling-container {
	//padding: 30px 0;
	//padding: 0 10px;
	position: relative;
	
	.rolling-list {
		user-select: none;
		white-space: nowrap;
		overflow: hidden;
		// scroll-behavior: smooth;
		
		.rolling {
			display: inline-block;
			
			>.rolling-item {
				display: inline-block;
				margin-right: 20px;
				width: 200px;
				height: 80px;
				aspect-ratio: 1.55 / 1;
				
				
				>img {
					// width: 268px;
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}
		}
	}
}

@media only screen and (max-width: 535px) {
	.rolling-container {
		
		.rolling-list {
			
			.rolling {
				
				>.rolling-item {
					margin-right: 10px;
					width: 100px;
					height: 40px;
					aspect-ratio: 1.55 / 1;
					
				}
			}
		}
	}
}
</style>